module.exports = __webpack_public_path__ + "img/Oncology.11f0286d.jpg";